/**
 * What is wrong with a typed lesson ID, or null. The lesson already in the
 * slot is not a swap, and a lesson already in another slot is refused by the
 * API ("A lesson can only fill one slot"), so two swaps cannot fake a reorder.
 */
export function swapIdError(
  value: string,
  currentId: string,
  idsInUse: ReadonlySet<string>,
): string | null {
  const id = value.trim();
  if (!id) return "Enter a lesson ID";
  if (!/^\d+$/.test(id)) return "ID must be numeric";
  // Leading zeros name the same lesson, as the lookup's Number() reads them.
  const canonical = String(Number(id));
  if (canonical === String(Number(currentId.trim()))) return "That's the current lesson";
  if (idsInUse.has(canonical)) return `ID ${canonical} is already in this curriculum`;
  return null;
}

/**
 * The name a swap shows and saves for a lesson. A lesson can have no name,
 * and a slot cannot save a blank title, so it falls back to "Lesson {id}" as
 * the Alloy design does.
 */
export function lessonDisplayName(lesson: { lesson_id: number; name: string | null }): string {
  return lesson.name?.trim() || `Lesson ${lesson.lesson_id}`;
}
